import currency from "currency.js";

const formatters = {
    USD: value => currency(value, { symbol: "$", precision: 2, formatWithSymbol: true }),
    CAD: value => currency(value, { symbol: "$", precision: 2, formatWithSymbol: true }),
    GBP: value => currency(value, { symbol: "£", precision: 2, formatWithSymbol: true }),
    AUD: value => currency(value, { symbol: "$", precision: 2, formatWithSymbol: true }),
    EUR: value =>
        currency(value, {
            symbol: "€",
            separator: ".",
            decimal: ",",
            precision: 2,
            pattern: "# !",
            formatWithSymbol: true
        }),
    CNY: value => currency(value, { symbol: "¥", precision: 2, formatWithSymbol: true }),
    NZD: value => currency(value, { symbol: "$", precision: 2, formatWithSymbol: true }),
    QAR: value =>
        currency(value, { symbol: "﷼", precision: 2, pattern: "! #", formatWithSymbol: true }),
    AED: value =>
        currency(value, { symbol: "دإ‏", precision: 2, pattern: "! #", formatWithSymbol: true }),
    SAR: value =>
        currency(value, { symbol: "﷼", precision: 2, pattern: "! #", formatWithSymbol: true }),
    ZAR: value =>
        currency(value, { symbol: "R", precision: 2, pattern: "! #", formatWithSymbol: true })
};

export function jrCurrency(value, code) {
    const rate = window.jrConfig.rates[code];
    if (rate && code !== "USD") {
        return formatters[code](value * rate).format(true) + " " + code;
    }
    return formatters.USD(value).format(true);
}
